import React, { ReactElement } from "react";
import { Global, css } from "@emotion/react";

export const ToolbarDisabledItemCss = (): ReactElement => {
  /**
   * CSS override description:
   * - Styles for disabled Toolbar Item (not present on Katana/Classic theme)
   *
   * This should be added to Spark's css in the future
   */

  return (
    <Global
      styles={css`
        /* Spark-React styles for disabled Toolbar Item */
        .spark-toolbar__item[aria-disabled="true"] {
          color: rgba(0, 0, 0, 0.3) !important;
          pointer-events: none !important;
          cursor: not-allowed !important;
        }
        .spark-toolbar__item[aria-disabled="true"]
          .spark-toolbar__item-helper:after {
          color: rgba(0, 0, 0, 0.3) !important;
          border-top-color: rgba(0, 0, 0, 0.3) !important;
        }
        .spark-toolbar__item[aria-disabled="true"]
          .spark-toolbar__item-helper:before {
          color: rgba(0, 0, 0, 0.3) !important;
        }
      `}
    />
  );
};

export const ToolbarCustomIconSvgCss = (): ReactElement => {
  /**
   * CSS override description:
   * - Styles for for custom svg icon:
   * For container--visible:
   * - Centering the custom svg icon
   * - Changing the fill color when the dropdown is open
   * For container--hidden:
   * - Removing the `margin: auto`, which is often applied to svg elements by default
   */

  return (
    <Global
      styles={css`
        /* Spark-React styles for custom svg icon */
        .spark-toolbar__container--visible .spark-toolbar__custom-svg-icon {
          justify-content: center;
        }
        .spark-toolbar__container--visible
          .spark-toolbar__item.open
          .spark-toolbar__custom-svg-icon
          svg {
          fill: #fff !important;
        }
        .spark-toolbar__container--hidden .spark-toolbar__custom-svg-icon svg {
          margin: 0;
        }
      `}
    />
  );
};

export const ToolbarShowMoreButtonTextCss = (): ReactElement => {
  return (
    <Global
      styles={css`
        .spark-toolbar__show-more-text {
          border-radius: 0.5rem !important;
          width: auto !important;
          height: auto !important;
          padding: 1rem !important;
          margin: 0.5rem 0;

          > span {
            text-transform: uppercase;
            font-weight: 700;
          }
        }
      `}
    />
  );
};

export const ToolbarShowItemsInSmallScreenCss = (): ReactElement => {
  return (
    <Global
      styles={css`
        .spark-toolbar
          .spark-toolbar__container--visible.spark-toolbar__container--visible--auto {
          width: 100% !important;
          visibility: inherit;
        }
        .spark-toolbar.show-more
          .spark-toolbar__container--visible.spark-toolbar__container--visible--auto {
          width: calc(100% - 4rem) !important;
        }
      `}
    />
  );
};
